import { Pipe, PipeTransform } from "@angular/core";
import { environment } from "../../../environments/environment";

@Pipe({
  name: "amount",
})
export class AmountPipe implements PipeTransform {
  transform(price: { amount: number; currency: string }): string {
    return !!price && !!price.amount
      ? `${price.amount.toFixed(2).toString().replace(".", ",")} ${
          price.currency || environment.defaultCurrency
        }`
      : `0,00 ${environment.defaultCurrency}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/amount/amount.pipe.ts